import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { getDestinations } from "../api";
import { useFavorites } from "../FavoritesContext";
import { useI18n, useL } from "../i18n";
import DestinationCard from "./DestinationCard";
import ReferralPanel from "./ReferralPanel";

export default function FavoritesPage() {
  const { ids } = useFavorites();
  const { t, lang } = useI18n();
  const L = useL();
  const [all, setAll] = useState([]);

  useEffect(() => {
    getDestinations({}).then(setAll);
  }, []);

  const favorites = all.filter((d) => ids.includes(d.id));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12" data-testid="favorites-page">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-[#C85A32] font-semibold">
          {L({ ar: "المفضلة", en: "Favorites", fr: "Favoris" })}
        </div>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl text-[#1C1917] flex items-center gap-3">
          <Heart className="h-7 w-7 fill-[#C85A32] text-[#C85A32]" />
          {L({ ar: "وجهاتك المحفوظة", en: "Your saved destinations", fr: "Vos destinations enregistrées" })}
        </h1>
      </div>

      {favorites.length === 0 ? (
        <div className="rounded-3xl border-2 border-dashed border-[#E6DED3] p-12 text-center">
          <Heart className="h-10 w-10 text-[#78716C] mx-auto" />
          <p className="mt-3 text-[#57534E]">
            {L({
              ar: "لم تضف أي وجهة إلى المفضلة بعد. ابدأ بالضغط على القلب على أي بطاقة.",
              en: "You haven't added any favorites yet. Tap the heart on any card to start.",
              fr: "Aucun favori pour l'instant. Appuyez sur le cœur d'une carte pour commencer."
            })}
          </p>
          <Link
            to="/"
            className="mt-5 inline-flex px-5 py-2.5 rounded-full bg-[#1C1917] text-[#FAF7F2] hover:bg-[#C85A32] transition-colors text-sm"
          >
            {t("hero_cta_explore")}
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
          {favorites.map((d) => <DestinationCard key={d.id} dest={d} />)}
        </div>
      )}

      <div className="mt-12">
        <ReferralPanel />
      </div>
    </div>
  );
}
